// Native scrolling — momentum smooth-scroll disabled for a snappier, standard feel.
export default function SmoothScroll({ children }) {
  return children;
}
